
import {
  SIGNALR_CONNECTED, SIGNALR_DISCONNECTED, SignalrConnected,
  SignalrDisconnected,
} from './actions/connection';

export type SignalrState = {
  connected: boolean;
};

const initialState: SignalrState = {
  connected: false,
};

// ---

type SignalrActions =
  | SignalrConnected
  | SignalrDisconnected;

export default function (state = initialState, action: SignalrActions): SignalrState {
  switch (action.type) {
    case SIGNALR_CONNECTED:
      return {
        ...state,
        connected: true,
      };

    case SIGNALR_DISCONNECTED:
      return {
        ...state,
        connected: false,
      };

    default:
      return state;
  }
}
